import React from 'react';
import { FaCheck } from 'react-icons/fa';

interface FeaturesMarkupProps {
	planDescription: string;
}

const FeaturesMarkup: React.FC<FeaturesMarkupProps> = ({ planDescription }) => (
	<div>
		{planDescription.split('\n').map((feature: string) => (
			<div key={feature} className='flex pb-0.5'>
				<div className='mr-[5px]'>
					<FaCheck size='1rem' />
				</div>
				<p className='mb-3'>{feature}</p>
			</div>
		))}
	</div>
);

export default FeaturesMarkup;
